import { render, staticRenderFns } from "./FormSignatureDetail.vue?vue&type=template&id=32a64b3c&scoped=true&"
import script from "./FormSignatureDetail.vue?vue&type=script&lang=js&"
export * from "./FormSignatureDetail.vue?vue&type=script&lang=js&"
import style0 from "./FormSignatureDetail.vue?vue&type=style&index=0&id=32a64b3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a64b3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32a64b3c')) {
      api.createRecord('32a64b3c', component.options)
    } else {
      api.reload('32a64b3c', component.options)
    }
    module.hot.accept("./FormSignatureDetail.vue?vue&type=template&id=32a64b3c&scoped=true&", function () {
      api.rerender('32a64b3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/newsletter/FormSignatureDetail.vue"
export default component.exports